// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2_Hyr","title":"Header_title__1iD-2","left":"Header_left__147p6","clinicName":"Header_clinicName__36RmN"};